import { ReactNode, memo } from 'react';

import useMasonryGridVerticalStyles from './MasonryGridVarticalJSS';

type MasonryColumnVerticalProps = {
  children: ReactNode | any;

  isDynamic?: boolean;

  XL_columnsCount?: number;
  XL_columnSize?: number;
  XL_columnWidth?: number | string;
  XL_gridVerticalGutter?: number;
  XL_gridHorizontalGutter?: number;

  LG_columnsCount?: number;
  LG_columnSize?: number;
  LG_columnWidth?: number | string;
  LG_gridVerticalGutter?: number;
  LG_gridHorizontalGutter?: number;

  MD_columnsCount?: number;
  MD_columnSize?: number;
  MD_columnWidth?: number | string;
  MD_gridVerticalGutter?: number;
  MD_gridHorizontalGutter?: number;

  SM_columnsCount?: number;
  SM_columnSize?: number;
  SM_columnWidth?: number | string;
  SM_gridVerticalGutter?: number;
  SM_gridHorizontalGutter?: number;
};

function MasonryColumnVertical({
  children,
  isDynamic,

  XL_columnsCount,
  XL_columnSize,
  XL_columnWidth,
  XL_gridVerticalGutter,
  XL_gridHorizontalGutter,

  LG_columnsCount,
  LG_columnSize,
  LG_columnWidth,
  LG_gridVerticalGutter,
  LG_gridHorizontalGutter,

  MD_columnsCount,
  MD_columnSize,
  MD_columnWidth,
  MD_gridVerticalGutter,
  MD_gridHorizontalGutter,

  SM_columnsCount,
  SM_columnSize,
  SM_columnWidth,
  SM_gridHorizontalGutter,
  SM_gridVerticalGutter,
}: MasonryColumnVerticalProps) {
  const masonryGridVerticalStylesClassNames = useMasonryGridVerticalStyles({
    isDynamic,

    XL_columnsCount,
    XL_columnSize,
    XL_columnWidth,
    XL_gridVerticalGutter,
    XL_gridHorizontalGutter,

    LG_columnsCount,
    LG_columnSize,
    LG_columnWidth,
    LG_gridVerticalGutter,
    LG_gridHorizontalGutter,

    MD_columnsCount,
    MD_columnSize,
    MD_columnWidth,
    MD_gridVerticalGutter,
    MD_gridHorizontalGutter,

    SM_columnsCount,
    SM_columnSize,
    SM_columnWidth,
    SM_gridHorizontalGutter,
    SM_gridVerticalGutter,
  } as any);

  return (
    <div className={masonryGridVerticalStylesClassNames.column}>{children}</div>
  );
}

export default memo<MasonryColumnVerticalProps>(MasonryColumnVertical);
